import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  LIST_CLASSIFICACAO_INIT,
  CREATE_CLASSIFICACAO_INIT,
  UPDATE_CLASSIFICACAO_INIT,
  DELETE_CLASSIFICACAO_INIT
} from '../actionTypes';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { classificacaoErrorMsg, createClassificacaoSuccess, deleteClassificacaoSuccess, listClassificacaoSuccess, updateClassificacaoSuccess } from './actions';
import { IClassificacao } from 'src/integracoes/servicos/mongo-atlas/modelos/IClassificacaoLoja';
import { atualizarClassificacao, criarClassificacao, deletarClassificacao, listarClassicacoes } from 'src/integracoes/servicos/mongo-atlas/funcoes/classificacoes';

interface FetchListaClassificacaoResult {
  isError: boolean;
  classificacoes: IClassificacao[] | null;
  errorMessage: string | null;
}

/* ------------------Lista classificacoes---------------- */
export const fetchListarClassificacao = async (): Promise<FetchListaClassificacaoResult> => {
  try {
    const { status, dados, mensagem } = await listarClassicacoes();

    if (status && Array.isArray(dados)) {
      return {
        isError: false,
        classificacoes: dados,
        errorMessage: null,
      };
    }

    return {
      isError: true,
      classificacoes: [],
      errorMessage: mensagem,
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarClassificacoes() {
  try {
    const result: FetchListaClassificacaoResult = yield call(fetchListarClassificacao);

    if (!result.isError) {
      yield put(listClassificacaoSuccess({ classificacoes: result.classificacoes }));
    } else {
      yield put(classificacaoErrorMsg({ msg: result.errorMessage }));
    }
  } catch (error: any) {
    yield put(
      classificacaoErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchListarClassificacoes() {
  yield takeEvery(LIST_CLASSIFICACAO_INIT, parseListarClassificacoes);
}


/* ------------------Criar classificacao ---------------- */
export const fetchCriarClassificacao = async (classificacao: any) => {
  try {
    const { status, dados, mensagem } = await criarClassificacao(classificacao);
    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarClassificacao({ payload }: { payload: any, type: any }) {
  const { classificacao } = payload;

  try {
    const { isCreated, msg, data } = yield call(fetchCriarClassificacao, classificacao);
    if (isCreated) {
      yield put(createClassificacaoSuccess({ msg, isCreated, classificacao: data }));
    } else {
      yield put(classificacaoErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      classificacaoErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchCriarClassificacao() {
  yield takeEvery(CREATE_CLASSIFICACAO_INIT, parseCriarClassificacao);
}

/* ------------------Atualiza classificacao ---------------- */
export const fetchAtualizarClassificacao = async (id: string, payload: any) => {
  try {
    const { status, dados, mensagem } = await atualizarClassificacao(id, payload);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, dados: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizarClassificacao({ payload }: { payload: any; type: any }) {
  const { id, classificacao } = payload;

  try {
    const { isUpdated, msg, dados } = yield call(fetchAtualizarClassificacao, id, classificacao);
    if (isUpdated) {
      yield put(updateClassificacaoSuccess({ msg, isUpdated, classificacao: dados }));
    } else {
      yield put(classificacaoErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      classificacaoErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchAtualizarClassificacao() {
  yield takeEvery(UPDATE_CLASSIFICACAO_INIT, parseAtualizarClassificacao);
}

/* ------------------Deletar classificacao ---------------- */
export const fetchDeletarClassificacao = async (id: string) => {
  try {
    const { status, mensagem, dados } = await deletarClassificacao(id);
    if (status) {
      return {
        isDeleted: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isDeleted: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDeletarClassificacao({ payload }: { payload: any; type: any }) {
  const { id } = payload;
  try {
    const { isDeleted, msg, data } = yield call(fetchDeletarClassificacao, id);

    if (isDeleted) {
      yield put(deleteClassificacaoSuccess({ msg, isDeleted, classificacao: data }));
    } else {
      yield put(classificacaoErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      classificacaoErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchDeletarClassificacao() {
  yield takeEvery(DELETE_CLASSIFICACAO_INIT, parseDeletarClassificacao);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchListarClassificacoes),
    fork(watchCriarClassificacao),
    fork(watchAtualizarClassificacao),
    fork(watchDeletarClassificacao)
  ]);
}
